// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__31LGo","menu":"Sidebar_menu__2Yutu","icon":"Sidebar_icon__QkdFd","active":"Sidebar_active__IkhmV"};